import { useState } from "react";
import styled, { keyframes } from "styled-components";
import { signUpApiCall } from "../Api.js";
import toast from 'react-hot-toast';
import {t} from '@lingui/core/macro';

const jump = keyframes`
  from{
    transform: translateY(0)
  }
  to{
    transform: translateY(-3px)
  }
`;

const Form = styled.form`
  margin: 0 auto;
  width: 90%;
  max-width: 414px;
  padding: 1.3rem;
  display: flex;
  flex-direction: column;
  position: relative;
`;

const Input = styled.input`
  max-width: 100%;
  padding: 11px 13px;
  background: #f9f9fa;
  color: #f03d4e;
  margin-bottom: 0.9rem;
  border-radius: 4px;
  outline: 0;
  border: 1px solid rgba(245, 245, 245, 0.7);
  font-size: 14px;
  transition: all 0.3s ease-out;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.1), 0 1px 1px rgba(0, 0, 0, 0.1);
  :focus,
  :hover {
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.15), 0 1px 5px rgba(0, 0, 0, 0.1);
  }
`;

const Button = styled.button`
  max-width: 100%;
  padding: 11px 13px;
  color: rgb(253, 249, 243);
  font-weight: 600;
  text-transform: uppercase;
  background: #f03d4e;
  border: none;
  border-radius: 3px;
  outline: 0;
  cursor: pointer;
  margin-top: 0.6rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease-out;
  &:hover {
    background: rgb(200, 50, 70);
    animation: ${jump} 0.2s ease-out forwards;
  }
`;

/**
 * A component to display a user signup form
 * @param {object} props
 * @param {fuction} props.handleSubmission A function that handles a successful signup
 * @returns {JSX.Element}
 */
const FormSignup = ({handleSubmission}) => {
  const [signup, setSignup] = useState({
    email: "",
    username: "",
    password: "",
    repassword: ""
  });

 /**
   * A function that handles a signup api call 
   * @param {object} e - An event dom object
   * @returns {void} Show an UI result and call a local storage function
   */
  const handleSubmitSignup = e => {
    e.preventDefault();
    signUpApiCall(signup).then(data => {
      console.log(data);
      if (data.success) {
       //set current login info cookie
        localStorage.setItem("isAuthenticated", true);
               toast( t`Account created successfully!`, {
                  icon: '👌',
                });
        handleSubmission();
      }
       else {
        toast(data.error.message ||  t`Generic account creation error`, {
          icon: '🥵',
        });
      }
    }
    )
      .catch(error => console.error(error));
  };

/**
   * A function that handles a user form change
   * @param {object} e - An event dom object
   * @returns {void} Set variables of state
   */
  const handleChange = e => {
    e.preventDefault();
    const { name, value } = e.target;
    setSignup({ ...signup, [name]: value })
  };

  return (
    <Form onSubmit={handleSubmitSignup}>
      <Input
        type="email"
        name="email"
        placeholder="Email"
        value={signup.email}
        onChange={handleChange}
      />
      <Input
        type="text"
        name="username"
        placeholder="Username"
        value={signup.name}
        onChange={handleChange}
      />
      <Input
        type="password"
        name="password"
        placeholder="Password"
        value={signup.password}
        onChange={handleChange}
      />
      <Input
        type="password"
        name="repassword"
        placeholder={t`Re-type password`}
        value={signup.repassword}
        onChange={handleChange}
      />
      <Button>{t`Signup`}</Button>
    </Form>

  );
}

export default FormSignup;
